module.exports = __webpack_public_path__ + "static/media/greenTick.122652c4_UI.svg";